import { render } from "./TextArea.vue?vue&type=template&id=281eb641&scoped=true&ts=true"
import script from "./TextArea.vue?vue&type=script&lang=ts"
export * from "./TextArea.vue?vue&type=script&lang=ts"

import "./TextArea.vue?vue&type=style&index=0&id=281eb641&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281eb641"]])

export default __exports__